import * as React from 'react';
import { LinkButton } from '@cian/ui-kit';

import { BLACK_FRIDAY_NEWBUILDING_LISTING_PARAMS } from '../../../../constants/blackFridayListings';
import { useNewbuildingListingUrl } from '../../../../hooks';

interface IBlackFridayListingLinkContainerProps {
  newbuildingCount: number;
  newbuildingIds: number[];
  onClick?(): void;
}

export const BlackFridayListingLinkContainer: React.FC<IBlackFridayListingLinkContainerProps> = ({
  newbuildingCount,
  newbuildingIds,
  onClick,
}) => {
  const newbuildingListingUrl = useNewbuildingListingUrl(newbuildingIds);
  const blackFridayNewbuildingListingUrl = `${newbuildingListingUrl}&${BLACK_FRIDAY_NEWBUILDING_LISTING_PARAMS}`;

  return (
    <LinkButton
      href={blackFridayNewbuildingListingUrl}
      onClick={onClick}
      rel="noopener noreferrer"
      size="L"
      target="_blank"
    >
      Смотреть {newbuildingCount} ЖК по акции
    </LinkButton>
  );
};
